<template>
	<div   >
		<el-dialog  title="编辑" :visible.sync="dialogVisible" @close="close" width="80%"   >
			
			<el-form label-width="80px" class="main"  v-loading="loading">
				<el-form-item label="商品图">
				    <el-upload
				      class="avatar-uploader"
				      :headers="headerObj"
				      :action="action"
				      :show-file-list="false"
				      :on-success="handleAvatarSuccess"
				      >
				      <img v-if="form.img" :src="form.img" class="avatar">
				      <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height: 140px;"></i>
				    </el-upload>
				</el-form-item>
					<el-form-item label="商品名称">
					   <el-input v-model="form.name" style="width: 80%;"></el-input>
					</el-form-item>
					<el-form-item label="商品分类">
						<el-select v-model="form.classify_id" placeholder="请选择">
						    <el-option
						      v-for="item in goods_classify"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						  </el-select>
					</el-form-item>
				
				<el-row>
					<el-col :span="10">
						<el-form-item label="价格">
						    <el-input v-model="form.price" style="width: 80%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="库存">
						    <el-input v-model="form.stock" style="width: 80%;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="是否易碎">
						    <template>
						      <el-radio v-model="form.is_ys" label="1">是</el-radio>
						      <el-radio v-model="form.is_ys" label="2">否</el-radio>
						    </template>

						</el-form-item>
					</el-col>
				</el-row>
				
				
				<el-form-item label="规格">
					<el-switch
					  v-model="form.is_norms"
					  active-color="#13ce66"
					  inactive-color="#ff4949">
					</el-switch><span style="color: red;margin-left: 20px;">开启后 原商品库存不启用</span>
				    <!-- <el-input v-model="form.stock" style="width: 80%;"></el-input> -->
				</el-form-item>
				
				<div v-if="form.is_norms">
					<test-edit ref="norms"  :goods_item="form.privateGoodsItem" :body_list="form.tableBodyList"></test-edit>
				</div>
			</el-form>
			<div style="height:30px"></div>
			<div style="height: 30px;text-align: center;">
				<el-button @click="tijiao" type="primary">保 存</el-button>
				 <el-button @click="close">关 闭</el-button>
			</div>
			<div style="height:30px"></div>
		</el-dialog>
	</div>
</template>
<script>
import TestEdit from './TestEdit.vue'
export default{
	name:'Edit',
	props:{
		id:String,
		type:String
	},
	components:{
		TestEdit
	},
	data(){
		return {
			action:this.$path()+"/index/Upload/index",
			dialogVisible:true,
			data:[],
			norms_show:false,
			loading: false,
			form:{
				img:"",
				name:"",
				classify_id:"",
				price:"",
				stock:"",
				is_norms:false,
				is_ys:"2",
				privateGoodsItem:[],
				tableBodyList:[],
			},
			goods_classify:[],
			headerObj:{
				token:sessionStorage.getItem("token")
			},
			res:[],
		}
	},
	methods:{
		all_data() {
			if(this.$refs.norms){
				this.form.privateGoodsItem=this.$refs.norms._data.privateGoodsItem
				this.form.tableBodyList=this.$refs.norms._data.tableColumnList.tableBodyList
			}
		},
		ChangeNorms(val){
			var self=this;
			self.res=[];
			this.norms_down_arr.forEach(function(value, key, item) {
				if(value.select_value!="" && value.select_value!=undefined){
					self.res.push(value.select_value)
				}
			});
			this.getData();
		},
		handleAvatarSuccess(res, file){
			if(res.errCode=='201'){
				this.$router.push({
					name:'/'
				})
				return;
			}
			 this.form.img = res.result;
		},
		close(){
			this.dialogVisible=false
			this.$emit("close")
		},
		async tijiao(){
			this.all_data();
			this.loading=true;
			var url="/index/Goods/Edit";
			var res=await this.$post(url,this.form)
			this.loading=false;
			if(res.errCode=="1"){
				this.$success(res,this)
				this.close();
			}else{
				this.$error(res,this)
			}
		},
		handleClick(tab, event){
		},
		async GetInfo(){
			var res=await this.$get("/index/Goods/Find",{"uuid":this.id})
			this.form=res.result;
		},
		async GetCode(){
			var res=await this.$get("/index/Code/GetClassifyCode","")
			this.goods_classify=res.result;
		}
	},
	mounted(){
		this.GetCode();
		if(this.id!="") this.GetInfo();
	}
}
</script>
<style scoped="scoped">
	.main{
		padding: 30px;
	}
	div{
		text-align: left;
	}
	.text{
		width: 80%;
	}
	/deep/ .el-dialog__body{
		overflow: hidden;
	}
	table {
		font-family: verdana,arial,sans-serif;
		font-size:11px;
		color:#333333;
		border-width: 1px;
		border-color: #666666;
		border-collapse: collapse;
		width: 100%;
	}
	table th {
		border-width: 1px;
		padding: 8px;
		border-style: solid;
		border-color: #666666;
		background-color: #dedede;
	}
	table td {
		border-width: 1px;
		padding: 8px;
		border-style: solid;
		border-color: #666666;
		background-color: #ffffff;
	}
</style>
<style>
	 .avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 140px;
	    height: 140px;
	    line-height: 140px;
	    text-align: center;
	  }
	  .avatar {
	    width: 140px;
	    height: 140px;
	    display: block;
	  }
	.zZindex {
	    z-index:9999 !important;
	}
</style>
